import React from 'react';
import clsx from 'clsx';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { DownFilled, FileArrowDown } from '../../icons';
import { Dialog, DialogContent, DialogTrigger } from '../ui/Modal';

export const ExportList = ({
  isOpen,
  exportOptions,
  setPopoverExport,
  handleExport,
  className = 'max-lg:hidden',
}) => {
  return (
    <Popover
      open={isOpen}
      onOpenChange={(open) => {
        setPopoverExport(open);
      }}
    >
      <PopoverTrigger
        className={clsx(
          'rounded-full text-white px-6 py-3 text-label flex gap-2 items-center max-lg:w-full justify-center',
          isOpen ? 'bg-[#282828]' : 'bg-primary',
          className
        )}
      >
        <FileArrowDown className="stroke-white" />
        Εξαγωγή Αρχείου
        <DownFilled />
      </PopoverTrigger>
      <PopoverContent className="flex flex-col gap-4 w-[150px]">
        {exportOptions.map((option, index) => (
          <div
            key={index}
            onClick={() => {
              handleExport(option.type);
            }}
            className="text-label w-full justify-between rounded-full border border-[#A5A5A5] text-[#282828] px-6 py-3 text-label flex items-center cursor-pointer"
          >
            {option.title}
            {option.icon}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export const ExportListMobile = ({
  isOpen,
  exportOptions,
  setPopoverExport,
  handleExport,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => setPopoverExport(open)}>
      <DialogTrigger>
        <FileArrowDown className="lg:hidden stroke-white stroke-1 bg-primary rounded-full p-1 h-8 w-8" />
      </DialogTrigger>
      <DialogContent className="px-6 pt-3 pb-10 grid">
        <h3>Εξαγωγή Αρχείου</h3>
        {exportOptions.map((option, index) => (
          <div
            key={index}
            onClick={() => {
              handleExport(option.type);
              setPopoverExport(false);
            }}
            className="text-label w-full justify-between rounded-full border border-[#A5A5A5] text-[#282828] px-6 py-3 text-label flex items-center cursor-pointer"
          >
            {option.title}
            {option.icon}
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};
